export default function(meta?: string): string {
  return 'Hawa | ' + (meta || 'Jaga keseimbangan alam')
}
